import { useOptionSalesType as useSalesType } from "@/components/features/items/edit/option/_shared/ui/components/sales-type/hooks";

import { useProductOptionFormModelContext } from "../../../../context";

export const useOptionSalesType = () => {
	const { viewModel, onSetViewModel } = useProductOptionFormModelContext();
	const { optionType, billingTypeTarget, maxBuyableNumPerTarget } = viewModel;

	return useSalesType({ onSetViewModel, optionType, billingTypeTarget, maxBuyableNumPerTarget });
};
